// extracted by mini-css-extract-plugin
module.exports = {"formControl":"ResetPassword_formControl_1TTbO"};